import { ListTicketViewRef } from 'app/pages/NewAccount/types';
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import { TAB_ORDER_MANAGEMENT } from '..';
import ListOrderLayout from '../ListOrderLayout';
import { ListOPrderManagementViewProps } from './ListOrderSuccess';
import useListOrder from '../useListOrder';

const ListOrderCancel = forwardRef<
  ListTicketViewRef,
  ListOPrderManagementViewProps
>(({ activeKeyTab, setLoading, loading }, ref) => {
  const isActiveCurrentTab = activeKeyTab === TAB_ORDER_MANAGEMENT.DA_HUY;
  const [isDisplayData, setIsDisplayData] = useState(isActiveCurrentTab);

  const { listOrder, paginator, search, optionsGetListOrder } = useListOrder({
    orderState: 'cancelled',
    isActiveTab: isActiveCurrentTab,
    setLoading,
    onFinally: () => {
      setIsDisplayData(true);
    },
  });
  useImperativeHandle(ref, () => {
    return {
      search,
      getCurrentSearchOpt: () => optionsGetListOrder,
    };
  });

  useEffect(() => {
    if (!isActiveCurrentTab) setIsDisplayData(false);
  }, [isActiveCurrentTab]);

  return (
    <ListOrderLayout
      loading={loading}
      paginator={paginator}
      listOrder={isDisplayData ? listOrder || [] : []}
      search={search}
      orderState={activeKeyTab}
      setIsLoading={setLoading}
      activeKeyTab={activeKeyTab}
    />
  );
});

export default ListOrderCancel;
